import { API_URL } from "constants";
import { apiRequest } from "./apiRequest";

export const getUrl = (eventId) => `${API_URL}/api/v2/appointments/current?id=${eventId}`;

export const getAppointment = async (eventId) => {
    const url = getUrl(eventId);
    return await apiRequest(url, "get");
};
